<template>
  <div>
    <h4>Союз Konjunktion</h4>

    <h6 class="fontbold">1. Союзы, которые связывают слова и группы слов</h6>

    <p>und, sowie, sowohl... als auch, weder ... noch, nicht... sondern, zwar ... aber, (entweder) ... oder</p>
    <blockquote>
      Muriel will Brot, Butter und Käse kaufen.
      <br />Sie hat weder Geld noch eine Kreditkarte dabei.
      <br />Das ist zwar schade, aber nicht zu ändern.
    </blockquote>

    <h6 class="fontbold">2. Союзы, которые связывают главные предложения</h6>

    <p>
      aber, denn, oder, und, sondern, doch u.a.
      Порядок слов в обоих предложениях не меняется.
    </p>
    <blockquote>
      Die Sonne scheint. Die Luft ist klar.
      <br />Die Sonne scheint und die Luft ist klar.
    </blockquote>
    <p>При одном и том же субъекте в обоих предложениях, часто субъект во втором предложениии не называется.</p>
    <blockquote>Ich bleibe nicht liegen, sondern (ich) stehe auf.</blockquote>

    <h6 class="fontbold">3. Союзы, которые связывают главное предложения и подчинённое предложение</h6>

    <p>
      als, als ob, (an)statt dass, bevor, bis, da, damit, dass, falls, nachdem, ob, obwohl, ohne dass, seit, so dass, während, weil, wenn, wie u.a.
      Глагол в подчинённом предложении всегда перемещается в конец предложения.
    </p>
    <blockquote>
      Ich mache einen Spaziergang, während du schläfst.
      <br />Ich bin froh, dass du mich nicht geweckt hast.
    </blockquote>


    <h6 class="fontbold">4. Наречия в качестве союзов</h6>

    <p>
      Некоторые наречия могут связывать предложения как союзы: darum, außerdem, trotzdem, dagegen, sonst, so u.a.       
      В этом случае глагол стоит сразу за наречием.
    </p>

    <div class="row">
      <div class="col s12 m10 l6">
        <table>
          <tbody>
            <tr>
              <td></td>
              <td>Hauptsatz.</td>
              <td>Hauptsatz.</td>             
            </tr>

            <tr>
              <td>Konjunktion</td>
              <td>Ich mache Abendbrot,</td>
              <td>denn ich habe Hunger.</td>             
            </tr>

            <tr>
              <td>Adverb</td>
              <td>Ich habe Hunger,</td>
              <td>darum mache ich Abendbrot.</td>             
            </tr>

          </tbody>
        </table>
      </div>
    </div>



  </div>
</template>


<style scoped>
.fontbold {
  font-weight: bold;
}
td {
  padding: 2px 2px;
}
</style>


<script>
export default {
  name: "grammatik_konjunktion",
  data: () => ({}),
  computed: {}
};
</script>
